import { cn } from "@aircall/ds";
import {
  type ComponentPropsWithoutRef,
  type ForwardedRef,
  forwardRef,
} from "react";

import type { InputChoiceContextValue } from "../../contexts/InputChoiceContext/InputChoiceContext.decl";
import { useInputChoice } from "../../contexts/useInputChoice";

export interface InputChoiceIconProps extends ComponentPropsWithoutRef<"div"> {
  "data-test"?: string;
}

function pickColorClass({
  isSelected,
  isDisabled,
}: InputChoiceContextValue): string {
  if (isDisabled) {
    return "text-muted-foreground";
  }

  if (isSelected) {
    return "text-primary-foreground";
  }

  return "text-foreground";
}

export const InputChoiceIcon = forwardRef<
  HTMLDivElement,
  InputChoiceIcon.Props
>(
  (
    componentProps: InputChoiceIcon.Props,
    forwardRef: ForwardedRef<HTMLDivElement>
  ) => {
    const {
      children,
      className,
      "data-test": dataTest = "input-choice-icon",
      ...props
    } = componentProps;
    const { isSelected, isDisabled } = useInputChoice();

    return (
      <div
        ref={forwardRef}
        data-slot="input-choice-icon"
        data-test={dataTest}
        className={cn(
          "flex items-center",
          pickColorClass({ isSelected, isDisabled }),
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);
InputChoiceIcon.displayName = "InputChoiceIcon";

export namespace InputChoiceIcon {
  export type Props = InputChoiceIconProps;
}
